import { IPosition } from '@medely/types';

export const BULK_CREATE_LOCATION_POSITION_IDS: IPosition['id'][] = [20, 24, 25];
